import { sha256Hmac } from './sha256Hmac'

async function calculateShaSignature(key: string, message: string) {
    return await sha256Hmac(key, message)
}

export default calculateShaSignature
